import LocalState, { ReporterState } from '../../state/LocalState';
import PendingReport from './report/PendingReport';
import { Report } from '../../reporter/report/Report';

export interface IReporter {
  cleanup: (useBeacon?: boolean) => void;
  playGuid?: string;
  state: ReporterState;
  stop: (useBeacon?: boolean) => void;
}

export enum TriggerAction {
  STOP_REPORTER = 'stopReporter'
}

export interface ReporterReadyInterface {
  localState: LocalState;
  state: ReporterState;
  initialReport: Report;
  pending: PendingReport;
}
